<template>
  <!-- 'suspension-top': suspensionStyle(wgt), 'suspension-bottom': suspensionStyle(wgt) } -->
  <div
    :class="{ 'wgt-suspension': true, 'suspension-top': value.position === 'top', 'suspension-bottom': value.position === 'bottom' }"
    :style="suspensionStyle">
    <div class="wgt-suspension-content">
      <div
        v-if="showMemberBenefitPreview"
        class="member-benefit-preview"
        :class="{ 'member-benefit-preview--closeable': resolvedIsCloseable == 'yes' }"
      >
        <div class="member-benefit-preview__content">
          <span class="member-benefit-preview__text">您有 </span>
          <span class="member-benefit-preview__highlight">5 张优惠券</span>
          <span class="member-benefit-preview__text">和</span>
          <span class="member-benefit-preview__highlight"> 1000 </span>
          <span class="member-benefit-preview__text">积分待使用</span>
        </div>
        <div class="member-benefit-preview__button">查看</div>
      </div>
      <CompHotimg :value="{data:resolvedDefaultSetting}" v-else-if="showDefaultSettingPreview"/>
      <CompHotimg :value="{data:currentContent}" :visible="visible" v-else-if="showCurrentPreview"/>
      <div v-if="resolvedIsCloseable == 'yes'" class="close-icon">
        <i class="el-icon-close"></i>
      </div>
    </div>
  </div>
</template>

<script>
import config from './config'
import CompHotimg from '../../comps/comp_hotImg';

const HOT_ZONE_MODE = 'hotZone'
const MEMBER_BENEFIT_MODE = 'memberBenefit'

export default {
  name: 'Suspension',
  wgtName: '悬浮层',
  wgtDesc: '',
  wgtIcon: 'wgt-suspension',
  wgtType: 1,
  wgtTem: 1,//0代表微信和抖音小程序都可以配置,1代表只能配置微信
  config: config,
  props: {
    value: [Object, Array]
  },
  data() {
    return {
      imgOffset: {
        width: 0,
        height: 0
      },
      refresh:false
    }
  },
  components: {
    CompHotimg
  },
  methods: {
    handleLode(e) {
      const { naturalWidth, naturalHeight } = e.target
      this.imgOffset = {
        width: naturalWidth,
        height: naturalHeight
      }
    }
  },
  computed: {
    suspensionStyle() {
      const { backgroundColor, backgroundImage, position, distance, margin, padding } = this.value
      let style = {
        backgroundColor,
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        margin: `0px ${margin.paddedr}px 0px ${margin.paddedl}px`,
        width: `calc(100% - ${margin.paddedl + margin.paddedr}px)`,
        padding: `${padding.paddedt}px ${padding.paddedr}px ${padding.paddedb}px ${padding.paddedl}px`,
      }
      if (position === 'top') {
        return {
          ...style,
          top: `${distance}px`,
        }
      } else {
        return {
          ...style,
          bottom: `${distance}px`,
        }
      }
    },
    contentData() {
      const rawData = this.value.data
      if (rawData && typeof rawData === 'object' && !Array.isArray(rawData)) {
        return rawData
      }
      return {}
    },
    resolvedVisibleRange() {
      return this.value.visibleRange || this.contentData.visibleRange || 'all'
    },
    resolvedDefaultSetting() {
      return this.value.defaultSetting || this.contentData.defaultSetting || {}
    },
    resolvedIsCloseable() {
      return this.value.isCloseable || this.contentData.isCloseable || 'no'
    },
    currentContent() {
      const { type } = this.contentData
      const typedContent = this.contentData[type] || {}
      return {
        imgUrl: '',
        data: [],
        imgName: '',
        ...(type === 'vip' ? { displayMode: HOT_ZONE_MODE } : {}),
        ...typedContent
      }
    },
    // 与 config.js 展示方式配置对应：all 读 data.vip.displayMode，vip 读 defaultSetting.displayMode
    previewDisplayMode() {
      const visibleRange = this.resolvedVisibleRange
      if (visibleRange === 'all') {
        if (this.contentData.type !== 'vip') {
          return HOT_ZONE_MODE
        }
        return this.currentContent.displayMode || HOT_ZONE_MODE
      }
      if (visibleRange === 'vip') {
        return this.resolvedDefaultSetting.displayMode || HOT_ZONE_MODE
      }
      return HOT_ZONE_MODE
    },
    visible() {
      return this.contentData.type === 'noVip'
    },
    showMemberBenefitPreview() {
      const visibleRange = this.resolvedVisibleRange
      if (visibleRange === 'all') {
        return this.contentData.type === 'vip' && this.previewDisplayMode === MEMBER_BENEFIT_MODE
      }
      if (visibleRange === 'vip') {
        return this.previewDisplayMode === MEMBER_BENEFIT_MODE
      }
      return false
    },
    showDefaultSettingPreview() {
      const visibleRange = this.resolvedVisibleRange
      if (visibleRange === 'all') return false
      if (visibleRange !== 'vip') return true
      return this.previewDisplayMode === HOT_ZONE_MODE
    },
    showCurrentPreview() {
      const visibleRange = this.resolvedVisibleRange
      if (visibleRange !== 'all') return false
      if (this.contentData.type !== 'vip') return true
      return this.previewDisplayMode === HOT_ZONE_MODE
    }
  },

}
</script>

<style lang="scss" scoped>
.wgt-suspension {
  box-sizing: border-box;
  min-height: 20px;

  .wgt-suspension-content {
    position: relative;

    .member-benefit-preview {
      min-height: 49px;
      padding: 10px 12px;
      border-radius: 8px;
      background: #f1effb;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;

      &__content {
        flex: 1;
        color: #666666;
        font-size: 12px;
        line-height: 20px;
        padding-right: 12px;
      }

      &__text {
        color: #666666;
      }

      &__highlight {
        color: #6974ff;
        font-weight: 600;
      }

      &__button {
        width: 36px;
        height: 22px;
        line-height: 22px;
        border-radius: 14px;
        background: linear-gradient(90deg, #8b88ff 0%, #6e76ff 100%);
        color: #fff;
        font-size: 10px;
        white-space: nowrap;
        text-align: center;
      }
    }

    .close-icon {
      position: absolute;
      // top: 5px;
      top: 50%;
      transform: translateY(-50%);
      right: 5px;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 10;
      transition: all 0.3s;

      i {
        color: #000;
        font-size: 14px;
      }
    }
  }
}
</style>

